import CloseIcon from "@mui/icons-material/Close";
import Button from "../editor/toolbar/Button";
import { ExpiredOfficerDocuments } from '../../common/JobOrder'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import moment from 'moment';
import { exportSingleSheetExcel } from '../../util/excelDocument';
import { FileOpen } from '@mui/icons-material';
import { useDownloadProfileDocumentMutation } from '../../redux/api/profileDocument';
import { useDownloadTrainingDocumentMutation } from '../../redux/api/trainingDocument';
import { ProfileDocumentTypeLabel } from '../../common/ProfileDocument';

const UpcomingExpiredOfficerDocuments = (props: {
  upcomingExpiredOfficerDocuments: ExpiredOfficerDocuments[];
  onClose: () => void;
}) => {
  const [downloadProfileDocument] = useDownloadProfileDocumentMutation();
  const [downloadTrainingDocument] = useDownloadTrainingDocumentMutation();

  const handleView = async (url: string, contentType: string, fileName: string, documentCategory: string) => {
    let response = null;

    if (documentCategory === 'PROFILE') {
      response = await downloadProfileDocument({
        fileKey: url,
      });
    } else {
      response = await downloadTrainingDocument({
        fileKey: url,
      });
    }

    if ("error" in response === false) {
      // @ts-ignore - if there is no error object in the response, we know it must have a Blob 'data' attribute
      const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      const inlineTypes = [
        'application/pdf',
        'image/png',
        'image/jpeg',
      ];

      if (inlineTypes.includes(contentType)) {
        window.open(url, "_blank");
      } else {
        const link = document.createElement("a");
        
        link.href = url;
        link.target = "_blank"
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  const exportFile = async () => {
    await exportSingleSheetExcel({
      data: props.upcomingExpiredOfficerDocuments,
      documentName: 'UpcomingExpiringOfficerDocuments',
      sheetName: 'Documents'
    }, [
      {
        label: "Vessel",
        name: "vesselName",
        width: 20,
      },
      {
        label: "Mariner",
        name: "marinerName",
        width: 40,
      },
      {
        label: "Document Name",
        name: "documentName",
        width: 20,
      },
      {
        label: "Document Type",
        name: "documentType",
        width: 20,
      },
      {
        label: "Expiration Date",
        name: "expirationDate",
        width: 20,
        custom: (row: any) => moment(row.expirationDate).format("MM/DD/YYYY"),
      },
    ]);
  };

  return (
    <div>
      <div className="flex align-items-center justify-content-btwn mb-1">
        <h1 className="mr-2">Upcoming Expiring Officer Documents</h1>
        <div className="flex g-1">
        <Button onClick={exportFile}>
          EXPORT TO EXCEL
        </Button>
        <Button onClick={props.onClose}>
          <CloseIcon />
        </Button>
        </div>
      </div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Vessel</TableCell>
            <TableCell>Mariner</TableCell>
            <TableCell>Document Name</TableCell>
            <TableCell>Document Type</TableCell>
            <TableCell>Expiration Date</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {props.upcomingExpiredOfficerDocuments.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.vesselName}</TableCell>
              <TableCell>{row.marinerName}</TableCell>
              <TableCell>{row.documentName}</TableCell>
              <TableCell>{(ProfileDocumentTypeLabel as Record<string, string>)[row.documentType] ?? row.documentType}</TableCell>
              <TableCell>{moment(row.expirationDate).format("MM/DD/YYYY")}</TableCell>
              <TableCell className="document-actions">
                <Button
                  className="blue-link-button"
                  onClick={() => {
                    handleView(row.fileKey, row.contentType, row.documentName, row.documentCategory);
                  }}
                >
                  <FileOpen />
                  View
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default UpcomingExpiredOfficerDocuments;

